import Validation from '@core/logic/Validation'
import CustomDependantsProtectionClient from '@company-common/model/kyc-form/needs-analysis/protection/CustomDependantsProtectionClient'
import DependantsProtection from '@master/model/kyc-form/need-analysis/protection/DependantsProtection'
interface Section {
  label: string;
  key: string;
}
// i. In the Event of Hospitalisation
const firstSectionKey: Section[] = [{
  label: '(i. Event of Hospitalisation)\'s Preferred Hospital Type',
  key: 'preferredHospitalType'
}, {
  label: '(i. Event of Hospitalisation)\'s Preferred Ward Type',
  key: 'preferredWardType'
}, {
  label: '(i. Event of Hospitalisation)\'s Rider for Deductible & Co-Insurance',
  key: 'riderDeductible'
}, {
  label: '(i. Event of Hospitalisation)\'s Existing hospital coverage',
  key: 'existingCoverage'
}]
// ii. In the Event of Critical Illness
const secondSectionKey: Section[] = [{
  label: '(ii. Event of Critical Illness)\'s Total Funds Required',
  key: 'totalFundsRequired'
}, {
  label: '(ii. Event of Critical Illness)\'s Less existing resources',
  key: 'iiLessExisting'
}]
// iii. In the Event of Disability
const thirdSectionKey: Section[] = [{
  label: '(iii. Event of Disability)\'s Annual expenses required',
  key: 'annualExpenses'
}, {
  label: '(iii. Event of Disability)\'s Number of years required',
  key: 'yearsRequired'
}, {
  label: '(iii. Event of Disability)\'s Inflation adjusted rate return',
  key: 'infAdjusted'
}, {
  label: '(iii. Event of Disability)\'s Cost of medical treatment',
  key: 'medicalTreatment'
}, {
  label: '(iii. Event of Disability)\'s Other funds available',
  key: 'otherFunds'
}]
// iv. In the Event of Death
const fortSectionKey: Section[] = [{
  label: '(iv. Event of Death)\'s Final Expenses',
  key: 'finalExpenses'
}, {
  label: '(iv. Event of Death)\'s Loans',
  key: 'loans'
}, {
  label: '(iv. Event of Death)\'s Others',
  key: 'others'
}, {
  label: '(iv. Event of Death)\'s Less existing resources',
  key: 'ivLessExisting'
}]

export default class DependantProtectionNeedsValidation extends Validation {
  validate (dependentsProtectionDataArray: CustomDependantsProtectionClient[], client1: DependantsProtection, client2: DependantsProtection, hasClient2: boolean, belongsTo: string) {
    this.belongsTo = belongsTo
    const section = 'Needs Analysis Calculation'
    const { getMessages, ADD } = this.validator()

    if (!client1.plan && (!hasClient2 || (hasClient2 && !client2.plan))) {
      return []
    }

    ADD(() => {
      if (dependentsProtectionDataArray.every(entry => !entry.depName)) {
        return 'There should be at least one Dependant’s Protection Needs Analysis selected.'
      }
    }, [section])

    //  check if any section is incomplete, then list the required field
    dependentsProtectionDataArray.forEach((dependents, index) => {
      if (!dependents.depName) return

      for (const sectionEntry of [firstSectionKey, secondSectionKey, thirdSectionKey, fortSectionKey]) {
        const partialCompletedSection = this.getPartialCompletedSection(sectionEntry, dependents)
        if (partialCompletedSection) {
          partialCompletedSection.forEach(eachField => {
            ADD(() => {
              return `Dependant ${index + 1} ${eachField} needs to be filled.`
            }, [section])
          })
        }
      }

      // check if all section is empty, if yes, then 'At least one of the Priorities for Dependant ' + (index + 1) + ' must be completed'
      const allSectionEmpty = [...firstSectionKey.flatMap(({ key }) => key), ...secondSectionKey.flatMap(({ key }) => key), ...thirdSectionKey.flatMap(({ key }) => key), ...fortSectionKey.flatMap(({ key }) => key)].every(key => this.isEmpty(dependents[key]))
      if (allSectionEmpty) {
        ADD(() => {
          return `At least one of the Priorities for Dependant ${index + 1} must be completed.`
        }, [section])
      }
    })

    return getMessages()
  }

  private getPartialCompletedSection (sectionKey: Section[], targetDependent) {
    const emptyFields = sectionKey.map(field => {
      if (field.key === 'preferredWardType' && targetDependent.preferredHospitalType === 'private') return
      if (this.isEmpty(targetDependent[field.key])) return field.label
    }).filter(data => data)
    // if emptyFields is same with sectionKey length means all section empty, no need do checking
    return emptyFields.length === sectionKey.length ? [] : emptyFields
  }
}
